<div class="setting-section">
  <div class="fc-vi-layout">

    <div class="fc-card">
      <div class="fc-card-header">
        <span class="material-icons fc-card-icon">api</span>
        <h3 class="fc-card-title">API Info</h3>
      </div>
      <div class="fc-card-body">
        <div *ngIf="infoDataApiError" class="fc-vi-error">
          <span class="material-icons">cloud_off</span>
          API unreachable
        </div>
        <ngx-json-viewer *ngIf="!infoDataApiError && infoDataApi" [json]="infoDataApi"></ngx-json-viewer>
        <div *ngIf="!infoDataApiError && !infoDataApi" class="fc-vi-loading">
          <span class="material-icons fc-spin">refresh</span>
          Loading…
        </div>
      </div>
    </div>

    <div class="fc-card">
      <div class="fc-card-header">
        <span class="material-icons fc-card-icon">dashboard</span>
        <h3 class="fc-card-title">Dashboard Web Info</h3>
      </div>
      <div class="fc-card-body">
        <ngx-json-viewer [json]="infoDataDashboard"></ngx-json-viewer>
      </div>
    </div>

  </div>
</div>
